<script lang="ts">
  import { Button, Form, Icon, Input } from '@bruce/components'
  import type { PageData } from './$types'
  import { RESET_STRINGS } from './strings'
  import { resetLinkSchema, resetSchema } from './schema'
  import { page } from '$app/stores'
  import Turnstile from '$lib/components/Turnstile.svelte'
  import { utils } from '$lib/utils'

  export let data: PageData
  $: ({ lang, isValid } = data)
  $: localeRoute = utils.getRoute(lang)
  $: linkSent = $page.url.searchParams.has('link-sent')
  $: resetPassword = $page.url.searchParams.has('secret')
  $: secret = $page.url.searchParams.get('secret') ?? ''
  $: passwordChanged = $page.url.searchParams.has('password-changed')
  let disabled = true
</script>

<h1>{RESET_STRINGS[lang].TITLE}</h1>
<Form
  multiSchema={{
    resetLink: resetLinkSchema(lang),
    reset: resetSchema(lang),
  }}
  action="?/resetLink"
>
  <section>
    {#if passwordChanged}
      <Icon color="success" icon="ph-check-circle-fill" size={10} />
      <h2>{RESET_STRINGS[lang].PASSWORD_CHANGED}</h2>
    {:else if resetPassword}
      {#if isValid}
        <Input
          label={RESET_STRINGS[lang].PASSWORD}
          type="password"
          name="password"
          variant="outlined"
          rounded
          block
          id="password"
          autofocus
          autocomplete="new-password"
          required
        />
        <Input
          label={RESET_STRINGS[lang].PASSWORD_CONFIRMATION}
          type="password"
          name="password_confirmation"
          variant="outlined"
          rounded
          block
          id="password_confirmation"
          required
        />
        <Input type="text" hidden name="secret" value={secret} />
        <Button
          type="submit"
          rounded
          block
          prependIcon="ph-paper-plane-tilt"
          formaction="?/reset"
        >
          {RESET_STRINGS[lang].CHANGE_PASSWORD}
        </Button>
        <Button
          variant="text"
          type="button"
          rounded
          on:click={() => window.Intercom('showNewMessage')}
        >
          {RESET_STRINGS[lang].NEED_HELP}
        </Button>
      {:else}
        <h2>{RESET_STRINGS[lang].LINK_EXPIRED}</h2>
        <Button
          rounded
          href={localeRoute('/password/reset')}
          prependIcon="ph-arrows-clockwise"
        >
          {RESET_STRINGS[lang].NEW_LINK}
        </Button>
      {/if}
    {:else if linkSent}
      <Icon color="success" icon="ph-check-circle-fill" size={10} />
      <h2>{RESET_STRINGS[lang].LINK_SENT}</h2>
    {:else}
      <Input
        label={RESET_STRINGS[lang].EMAIL}
        type="email"
        name="email"
        variant="outlined"
        rounded
        block
        prependIcon="ph-envelope"
        id="email"
        autocomplete="email"
        autofocus
        required
      />
      <Turnstile on:turnstile-callback={() => (disabled = false)} />
      <Button
        type="submit"
        rounded
        block
        prependIcon="ph-paper-plane-tilt"
        {disabled}
      >
        {RESET_STRINGS[lang].SEND_LINK}
      </Button>
      <Button
        variant="text"
        type="button"
        rounded
        on:click={() => window.Intercom('showNewMessage')}
      >
        {RESET_STRINGS[lang].NEED_HELP}
      </Button>
    {/if}
  </section>
</Form>

<style lang="scss">
  section {
    display: flex;
    flex-direction: column;
    align-items: center;
    gap: 1em;
    margin-top: 1em;
  }
</style>
